const technologies = [
  { name: 'React', icon: '⚛️' },
  { name: 'Next.js', icon: '▲' },
  { name: 'Vue', icon: '💚' },
  { name: 'Astro', icon: '🚀' },
  { name: 'TypeScript', icon: '🔷' },
  { name: 'JavaScript', icon: '🟨' },
  { name: 'Tailwind CSS', icon: '🌊' },
  { name: 'Node.js', icon: '💚' },
  { name: 'Python', icon: '🐍' },
  { name: 'MySQL', icon: '🐬' },
  { name: 'Git', icon: '🔀' },
  { name: 'React', icon: '⚛️' },
  { name: 'Next.js', icon: '▲' },
  { name: 'Vue', icon: '💚' },
  { name: 'Astro', icon: '🚀' },
  { name: 'TypeScript', icon: '🔷' },
  { name: 'JavaScript', icon: '🟨' },
  { name: 'Tailwind CSS', icon: '🌊' },
  { name: 'Node.js', icon: '💚' },
  { name: 'Python', icon: '🐍' },
  { name: 'MySQL', icon: '🐬' },
  { name: 'Git', icon: '🔀' },
];

function TechCarousel() {
  return (
    <div className="relative overflow-x-hidden py-10 -mx-6 md:-mx-8">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent z-20" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent z-20" />
      <div className="flex animate-scroll hover:animate-paused gap-16 md:gap-24 w-max">
        {technologies.map((tech, i) => (
          <div
            key={i}
            className="flex items-center gap-3 group transition-all duration-300"
          >
            <span className="text-2xl md:text-3xl opacity-60 group-hover:opacity-100 transition-opacity group-hover:scale-110 inline-block">
              {tech.icon}
            </span>
            <span className="text-lg md:text-xl font-medium text-on-surface-variant group-hover:text-white transition-colors whitespace-nowrap">
              {tech.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TechCarousel;
